import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createBlock as _createBlock, withCtx as _withCtx, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/images/no-data.png'
import _imports_1 from '@/assets/images/create-point.png'


const _hoisted_1 = { class: "list-container" }
const _hoisted_2 = { class: "list-header-title" }
const _hoisted_3 = { class: "list-content-item" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "list-content-item-header-left" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "list-content-item-header-title" }
const _hoisted_8 = {
  key: 0,
  class: "list-content-item-header-right"
}
const _hoisted_9 = { class: "time" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = ["onClick"]
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { class: "list-content-item-title" }
const _hoisted_14 = { class: "list-content-item-context" }
const _hoisted_15 = {
  key: 1,
  class: "list-content-item-content"
}
const _hoisted_16 = {
  key: 1,
  class: "no-create-box"
}


import { formatTime, copyTexts } from '@/utils';

interface HistoryItem {
  id: string;
  name: string;
  img: string;
  title: string;
  context: string;
  tag: string;
  loading: boolean;
  generatedTime: string;
  contextHtml: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'GeneratedContentList',
  props: {
  historyList: {
    type: Array<HistoryItem>,
    required: true,
  },
  typeTitle: {
    type: String,
    required: true,
  },
  title: {
    type: String,
    required: true,
    default: '生成内容',
  },
  showDelete: {
    type: Boolean,
    default: true,
  },
},
  emits: ['handleDelete', 'handleClick'],
  setup(__props, { emit: __emit }) {

const emit = __emit;

const getHtml = (item: HistoryItem) => {
  if (item.contextHtml && item.contextHtml.startsWith('<p>')) {
    return item.contextHtml.slice(3, -4);
  }
  return item.contextHtml || item.context;
};

const props = __props;

const getTags = (tag: string) => {
  if (!tag) return [];
  return tag.split('#').filter(Boolean);
};

const handleCopy = (item: HistoryItem) => {
  // 复制标题和内容
  copyTexts(item.title + item.context);
};

const deleteItem = (item: HistoryItem) => {
  emit('handleDelete', item);
};

const clickItem = (item: HistoryItem) => {
  emit('handleClick', item);
};

return (_ctx: any,_cache: any) => {
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_skeleton = _resolveComponent("el-skeleton")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.historyList.length > 0)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("div", _hoisted_2, _toDisplayString(__props.title), 1),
          _createVNode(_component_el_row, { gutter: 16 }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.historyList, (item) => {
                return (_openBlock(), _createBlock(_component_el_col, {
                  span: 8,
                  key: item.id,
                  class: "list-content"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_3, [
                      _createElementVNode("div", {
                        class: "list-content-item-header",
                        onClick: ($event: any) => (clickItem(item))
                      }, [
                        _createElementVNode("div", _hoisted_5, [
                          _createElementVNode("img", {
                            class: "list-content-item-header-img-logo",
                            src: item.img,
                            alt: ""
                          }, null, 8, _hoisted_6),
                          _createElementVNode("div", _hoisted_7, _toDisplayString(item.name), 1)
                        ]),
                        (!item.loading)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                              _createElementVNode("div", _hoisted_9, _toDisplayString(_unref(formatTime)(item.generatedTime)), 1),
                              _createVNode(_component_el_divider, { direction: "vertical" }),
                              _createElementVNode("div", {
                                class: "copy-btn",
                                onClick: _withModifiers(($event: any) => (handleCopy(item)), ["stop"])
                              }, _cache[0] || (_cache[0] = [
                                _createElementVNode("i", { class: "ri-file-copy-line" }, null, -1)
                              ]), 8, _hoisted_10),
                              (__props.showDelete)
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 0,
                                    class: "delete-btn",
                                    onClick: _withModifiers(($event: any) => (deleteItem(item)), ["stop"])
                                  }, _cache[1] || (_cache[1] = [
                                    _createElementVNode("i", { class: "ri-delete-bin-5-line" }, null, -1)
                                  ]), 8, _hoisted_11))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true)
                      ], 8, _hoisted_4),
                      (!item.loading)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: "list-content-item-content",
                            onClick: ($event: any) => (clickItem(item))
                          }, [
                            _createElementVNode("div", _hoisted_13, _toDisplayString(item.title), 1),
                            _createElementVNode("div", _hoisted_14, _toDisplayString(item.context), 1)
                          ], 8, _hoisted_12))
                        : (_openBlock(), _createElementBlock("div", _hoisted_15, [
                            _withDirectives(_createVNode(_component_el_skeleton, {
                              rows: 5,
                              animated: "",
                              "element-loading-text": "正在生成中...",
                              "element-loading-background": "rgba(122, 122, 122, 0.0)"
                            }, null, 512), [
                              [_directive_loading, true]
                            ])
                          ])),
                      (item.tag)
                        ? (_openBlock(), _createBlock(_component_el_tabs, {
                            key: 2,
                            size: "small",
                            class: "list-content-item-tags"
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getTags(item.tag), (tag, index) => {
                                return (_openBlock(), _createBlock(_component_el_tab_pane, {
                                  size: "small",
                                  key: index,
                                  label: `#${tag.trim()}`,
                                  name: tag.trim()
                                }, null, 8, ["label", "name"]))
                              }), 128))
                            ]),
                            _: 2
                          }, 1024))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          })
        ], 64))
      : (_openBlock(), _createElementBlock("div", _hoisted_16, _cache[2] || (_cache[2] = [
          _createStaticVNode("<div class=\"no-data-content\" data-v-04475578><div data-v-04475578><img src=\"" + _imports_0 + "\" alt=\"\" data-v-04475578></div></div><div class=\"create-point\" data-v-04475578><img src=\"" + _imports_1 + "\" alt=\"\" data-v-04475578><div class=\"point-title\" data-v-04475578>AI创作结果会在显示这里 现在，你只需要</div></div><div class=\"create-tip\" data-v-04475578><div class=\"tip-1\" data-v-04475578>1. 在左侧填好必要的信息，填写越详细，结果越准确哦</div><div class=\"tip-2\" data-v-04475578>2. 点击立即生成按钮，静待AI妙笔生花，一般在1分钟内搞定</div></div>", 3)
        ])))
  ]))
}
}

})